console.log("HOME TRIAL JS LOADED");

window.HomeTrialPing = function () {
  alert("HOME TRIAL JS IS RUNNING");
};

(() => {
  const MAX = 3;
  const TRYON_TEXT = "- TRY ON";
  const EMPTY_FRAME_IMAGE =
    "https://cdn.shopify.com/s/files/1/0617/5532/6537/files/Frame_Image_Gray.jpg?v=1772941635";

  let lastTryOnCount = null;
  let toastTimer = null;
  let removeBusy = false;

  function isTryOnItem(item) {
    return (item?.title || "").includes(TRYON_TEXT);
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load cart");
    return res.json();
  }

  async function removeCartLine(line) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Accept: "application/json",
      },
      body: new URLSearchParams({
        line: String(line),
        quantity: "0",
      }).toString(),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`Remove failed (${res.status}) ${txt}`);
    }

    return res.json().catch(() => null);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function moveUIToBody() {
    const drawer = document.getElementById("HomeTrialDrawer");
    const toast = document.getElementById("HomeTrialToast");

    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    if (toast && toast.parentElement !== document.body) {
      document.body.appendChild(toast);
    }
  }

  function suppressNativeTryOnPopup() {
    const nodes = Array.from(document.body.querySelectorAll("div"));

    for (const node of nodes) {
      const text = (node.textContent || "").trim();
      const style = node.getAttribute("style") || "";

      if (
        text.includes("Added to cart (Try-On)") &&
        style.includes("position:fixed") &&
        (style.includes("background:#111") || style.includes("background: #111"))
      ) {
        node.remove();
      }
    }
  }

  function setupPopupSuppressor() {
    suppressNativeTryOnPopup();

    const observer = new MutationObserver(() => {
      suppressNativeTryOnPopup();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    moveUIToBody();
    setupPopupSuppressor();

    const els = {
      badge: document.querySelector("[data-home-trial-count]"),
      countInline: document.querySelector("[data-home-trial-count-inline]"),
      drawer: document.getElementById("HomeTrialDrawer"),
      list: document.querySelector("[data-home-trial-list]"),
      toast: document.getElementById("HomeTrialToast"),
      toastText: document.querySelector("[data-home-trial-toast-text]"),
      openBtn: document.querySelector("[data-home-trial-open]"),
      closeBtns: Array.from(document.querySelectorAll("[data-home-trial-close]")),
      goCartBtn: document.querySelector("[data-home-trial-go-cart]"),
    };

    if (!els.drawer || !els.list) return;

    function setCount(count) {
      const safeCount = Math.min(count, MAX);

      if (els.badge) {
        els.badge.hidden = safeCount <= 0;
        els.badge.textContent = String(safeCount);
      }

      if (els.countInline) {
        els.countInline.textContent = String(safeCount);
      }
    }

    function pageIsTryOnProduct() {
      const productTitle =
        document.querySelector("h1.product-title") ||
        document.querySelector(".product-title") ||
        document.querySelector(".product__title") ||
        document.querySelector("h1");

      const text = (productTitle?.textContent || "").toUpperCase();
      return text.includes("TRY ON");
    }

    function findTryOnButtons() {
      return Array.from(
        document.querySelectorAll("button, input[type='submit'], [role='button']")
      ).filter((el) => {
        const text = ((el.textContent || "") + " " + (el.value || "")).toUpperCase();
        const cls = typeof el.className === "string" ? el.className.toUpperCase() : "";
        const id = (el.id || "").toUpperCase();

        const isActualCartButton =
          el.closest('form[action*="/cart/add"]') ||
          el.closest("product-form") ||
          el.getAttribute("name") === "add";

        const isInfoOrModalButton =
          el.closest("#tryon-modal") ||
          el.closest(".tryon-modal") ||
          el.closest(".tryon-modal-x-div") ||
          el.closest(".virtual-try-on") ||
          el.closest(".tryon-info") ||
          el.classList.contains("tryon-modal-x-div") ||
          id.includes("LEARN") ||
          cls.includes("LEARN") ||
          text.includes("LEARN MORE");

        return (
          isActualCartButton &&
          !isInfoOrModalButton &&
          (
            text.includes("TRY ON") ||
            text.includes("TRYON") ||
            cls.includes("TRYON") ||
            id.includes("TRYON")
          )
        );
      });
    }

    function lockTryOnButtons() {
      if (!pageIsTryOnProduct()) return;

      findTryOnButtons().forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.setAttribute("aria-disabled", "true");
        btn.style.pointerEvents = "none";
        btn.style.opacity = "0.55";
        btn.style.cursor = "not-allowed";
      });
    }

    function unlockTryOnButtons() {
      if (!pageIsTryOnProduct()) return;

      findTryOnButtons().forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.setAttribute("aria-disabled", "false");
        btn.style.pointerEvents = "";
        btn.style.opacity = "";
        btn.style.cursor = "";
      });
    }

    function syncTryOnButtonState(count) {
      if (!pageIsTryOnProduct()) return;

      if (count >= MAX) {
        lockTryOnButtons();
      } else {
        unlockTryOnButtons();
      }
    }

    function restoreTryonAppButtonText(count) {
      if (!pageIsTryOnProduct()) return;

      if (count < MAX) {
        document.querySelectorAll(".tryon-selling-plan-name-span").forEach(function (span) {
          const text = span.textContent.trim();

          if (
            text === "Reached the maximum Try-On items" ||
            text === "Reached the maximum Tryon items"
          ) {
            span.textContent = "Try before you buy";
          }
        });

        findTryOnButtons().forEach((btn) => {
          btn.removeAttribute("disabled");
          btn.setAttribute("aria-disabled", "false");
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
          btn.style.cursor = "";
        });
      }
    }

    function getSelectedVariantIdFromPage() {
      const form =
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector("product-form form") ||
        document.querySelector("form");

      if (!form) return null;

      const variantInput =
        form.querySelector('input[name="id"]') ||
        document.querySelector('input[name="id"]');

      return variantInput && variantInput.value ? String(variantInput.value) : null;
    }

    function hasDuplicateTryOnVariant(cart) {
      if (!pageIsTryOnProduct()) return false;

      const selectedVariantId = getSelectedVariantIdFromPage();
      if (!selectedVariantId) return false;

      return (cart.items || []).some((item) => {
        if (!isTryOnItem(item)) return false;

        const cartVariantId =
          item.variant_id || item.id || item.variantId || item.product_id;

        return String(cartVariantId) === selectedVariantId;
      });
    }

    function hideToast() {
      if (els.toast) els.toast.hidden = true;
    }

    function showDuplicateToast() {
      if (!els.toast || !els.toastText) return;

      els.toastText.innerHTML =
        `This TRY ON frame has already been added to cart. <span class="home-trial-toast__link home-trial-toast-open">View my Home Trial</span>`;

      els.toast.hidden = false;

      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        hideToast();
      }, 5000);
    }

    function showMaxTryOnToast() {
      if (!els.toast || !els.toastText) return;

      els.toastText.innerHTML =
        `3 of 3 frames added. <span class="home-trial-toast__link home-trial-toast-open">View my Home Trial</span>`;

      els.toast.hidden = false;

      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        hideToast();
      }, 5000);
    }

    function openDrawer() {
      els.drawer.hidden = false;
      document.documentElement.classList.add("home-trial-open");
    }

    function closeDrawer() {
      els.drawer.hidden = true;
      document.documentElement.classList.remove("home-trial-open");
    }

    function showToast(count) {
      if (!els.toast || !els.toastText) return;

      const safeCount = Math.min(count, MAX);

      els.toastText.innerHTML =
        `${safeCount} of ${MAX} frames added. <span class="home-trial-toast__link home-trial-toast-open">View my Home Trial</span>`;

      els.toast.hidden = false;

      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        hideToast();
      }, 5000);
    }

    function renderList(items) {
      const filledItems = (items || []).slice(0, MAX);
      const emptyCount = Math.max(0, MAX - filledItems.length);

      const filledHtml = filledItems
        .map((item) => {
          const line = item.__line;
          const img = item.image || "";
          const name = (item.product_title || item.title || "")
            .replace(TRYON_TEXT, "")
            .trim();

          const variant =
            item.variant_title && item.variant_title !== "Default Title"
              ? item.variant_title
              : "";

          return `
            <div class="home-trial-item">
              <img class="home-trial-item__img" src="${img}" alt="${escapeHtml(name)}">
              <div>
                <div class="home-trial-item__name">${escapeHtml(name)}</div>
                ${variant ? `<div class="home-trial-item__variant">${escapeHtml(variant)}</div>` : ""}
              </div>
              <button
                class="home-trial-item__remove"
                type="button"
                aria-label="Remove ${escapeHtml(name)}"
                onpointerdown="event.preventDefault(); event.stopPropagation(); if (event.stopImmediatePropagation) event.stopImmediatePropagation(); this.disabled=true; fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' }, body: new URLSearchParams({ line: '${line}', quantity: '0' }).toString() }).then(async () => { if (window.HomeTrialRefreshUI) { await window.HomeTrialRefreshUI({ preserveDrawer: true, suppressToast: true }); } const drawer = document.getElementById('HomeTrialDrawer'); if (drawer) drawer.hidden = false; document.documentElement.classList.add('home-trial-open'); }).catch(console.error).finally(() => { this.disabled=false; }); return false;"
                onclick="return false;"
              >×</button>
            </div>
          `;
        })
        .join("");

      const emptyHtml = Array.from({ length: emptyCount })
        .map(() => {
          return `
            <div class="home-trial-item home-trial-item--empty">
              <div class="home-trial-item__img home-trial-item__img--empty">
                <img src="${EMPTY_FRAME_IMAGE}" alt="CHOOSE A FRAME">
              </div>
              <div>
                <a
                  href="https://www.velenci.com/collections/in-home-try-on"
                  class="home-trial-item__name home-trial-item__name--empty"
                  style="text-decoration:none;color:inherit;"
                >
                  CHOOSE A FRAME
                </a>
              </div>
              <div></div>
            </div>
          `;
        })
        .join("");

      els.list.innerHTML = filledHtml + emptyHtml;
    }

    async function refreshUI(options = {}) {
      const { preserveDrawer = false, suppressToast = false } = options;

      try {
        const cart = await getCart();

        const tryOnItems = (cart.items || [])
          .map((item, index) => ({ ...item, __line: index + 1 }))
          .filter(isTryOnItem);

        const count = tryOnItems.length;

        setCount(count);
        renderList(tryOnItems);
        syncTryOnButtonState(count);
        restoreTryonAppButtonText(count);

        if (
          lastTryOnCount !== null &&
          !suppressToast &&
          count > lastTryOnCount &&
          count <= MAX
        ) {
          showToast(count);
        }

        if (preserveDrawer) {
          openDrawer();
        }

        lastTryOnCount = count;
        return tryOnItems;
      } catch (err) {
        console.error("[HomeTrial] refreshUI error:", err);
      }
    }

    window.refreshHomeTrialUI = refreshUI;
    window.HomeTrialRefreshUI = refreshUI;

    window.HomeTrialRemoveByLine = async function (rawLine) {
      const line = Number(rawLine);
      if (!line || removeBusy) return;

      removeBusy = true;

      try {
        await removeCartLine(line);
        await refreshUI({ preserveDrawer: true, suppressToast: true });
      } catch (err) {
        console.error("[HomeTrial] remove error:", err);
      } finally {
        removeBusy = false;
      }
    };

    if (els.openBtn) {
      els.openBtn.addEventListener("click", async () => {
        await refreshUI({ preserveDrawer: true, suppressToast: true });
        openDrawer();
      });
    }

    els.closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        closeDrawer();
      });
    });

    if (els.goCartBtn) {
      els.goCartBtn.addEventListener("click", () => {
        window.location.href = "/cart";
      });
    }

    document.addEventListener("click", (e) => {
      const toastOpen = e.target.closest(".home-trial-toast-open");

      if (toastOpen) {
        e.preventDefault();
        hideToast();
        openDrawer();
      }
    });

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) refreshUI({ suppressToast: true });
    });

    document.addEventListener("cart:refresh", () => refreshUI());
    document.addEventListener("cart:updated", () => refreshUI());
    document.addEventListener("home-trial:updated", () => refreshUI());

    document.addEventListener("variant:change", () => {
      setTimeout(() => refreshUI({ suppressToast: true }), 150);
      setTimeout(() => refreshUI({ suppressToast: true }), 500);
    });

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
      try {
        const requestUrl =
          typeof args[0] === "string"
            ? args[0]
            : args[0] && args[0].url
              ? args[0].url
              : "";

        const isCartAdd =
          requestUrl.includes("/cart/add") || requestUrl.includes("/cart/add.js");

        if (isCartAdd) {
          const cart = await getCart();
          const tryOnItems = (cart.items || []).filter(isTryOnItem);
          const tryOnCount = tryOnItems.length;

          if (pageIsTryOnProduct() && hasDuplicateTryOnVariant(cart)) {
            await refreshUI({ suppressToast: true });
            showDuplicateToast();

            return new Response(
              JSON.stringify({
                status: 422,
                message: "Duplicate TRY ON variant",
                description: "This TRY ON frame has already been added to cart."
              }),
              {
                status: 422,
                headers: { "Content-Type": "application/json" }
              }
            );
          }

          if (pageIsTryOnProduct() && tryOnCount >= MAX) {
            syncTryOnButtonState(tryOnCount);
            await refreshUI({ suppressToast: true });
            showMaxTryOnToast();

            return new Response(
              JSON.stringify({
                status: 422,
                message: "Maximum TRY ON items reached",
                description: "You already have 3 TRY ON frames in your cart."
              }),
              {
                status: 422,
                headers: { "Content-Type": "application/json" }
              }
            );
          }
        }

        const response = await originalFetch.apply(this, args);

        if (isCartAdd) {
          setTimeout(() => refreshUI(), 150);
          setTimeout(() => refreshUI(), 500);
          setTimeout(() => refreshUI(), 900);
        }

        return response;
      } catch (err) {
        console.error("[HomeTrial] fetch hook error:", err);
        return originalFetch.apply(this, args);
      }
    };

    refreshUI({ suppressToast: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();